import { WishItem } from "./WishItem"

export const WISH_ITEM_DEFINITIONS: WishItem[] = [
  { id: 1, value: "イラスト" },
  { id: 2, value: "設定集" },
  { id: 3, value: "小説" },
  { id: 4, value: "制作過程の資料(オリジナル)" },
  { id: 5, value: "制作過程の資料(たいあっぷノベルの作品)" },
  { id: 6, value: "制作過程の資料(二次創作)" },
  { id: 7, value: "その他" },
]
